'use strict';

wbApp.factory('surveyResponseSvc', ['$resource', 'repositorySvc',
    function ($resource, repositorySvc) {

        var SurveyResponse = $resource('/Api/SurveyResponses/GetAll', {}, {
            'getByResponseID' : { method: 'GET', url: '/Api/SurveyResponses/Get', isArray: false },
            'query': { method: 'GET', url: '/Api/SurveyResponses/GetDetailBySurveyID', isArray: true },
            'getExcelExportBySurveyID': { method: 'POST', url: '/Api/SurveyResponses/GetExcelExportBySurveyID' }

        });

        function getByResponseIDAyns(surveyResponseID) {
            return repositorySvc.customGet('getByResponseID', SurveyResponse, { surveyResponseID: surveyResponseID });
        }

        function getAllBySurveyIDAsync(surveyID) {
            return repositorySvc.get(SurveyResponse, { surveyID: surveyID });
        }

        function getQuestionWithAnswersModel(questions, answers) {
            var res = [];

            _.forEach(questions, function (q) {
                var a = _.find(answers, { 'surveyQuestionID': q.surveyQuestionID });

                res.push({
                    surveyQuestionTypeID: q.surveyQuestionTypeID,
                    question: q.question,
                    allowCustomNote: q.allowCustomNote,
                    bitAnswer: !a ? true : a.bitAnswer,
                    intAnswer: !a ? 3 : a.intAnswer,
                    textAnswer: !a ? '' : a.textAnswer
                });
            });

            return res;
        }

        function getExcelExportBySurveyID(surveyID) {
            return repositorySvc.customPost('getExcelExportBySurveyID', SurveyResponse, {
                surveyID: surveyID
            });
        }

        return {
            getAllBySurveyIDAsync: getAllBySurveyIDAsync,
            getByResponseIDAyns: getByResponseIDAyns,
            getQuestionWithAnswersModel: getQuestionWithAnswersModel,
            getExcelExportBySurveyID: getExcelExportBySurveyID
        }
    }
]);